const CATCH_ERROR = {
  error: "An unexpected error occurred. Please try again later.",
};

let urlprefix = import.meta.env.BASE_URL + "/api";

export const submitForm = (data) => {
  return new Promise((resolve, reject) => {
    fetch(urlprefix + "/SubmitForm", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) =>
        response.json().then((res) => {
          if (res.error) {
            reject(res);
          } else {
            resolve(res);
          }
        })
      )
      .catch((err) => {
        reject(CATCH_ERROR);
      });
  });
};

export const updateCapacity = (data) => {
  return new Promise((resolve, reject) => {
    fetch(urlprefix + "/UpdateCapacity", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) =>
        response.json().then((res) => {
          if (res.error) {
            reject(res);
          } else {
            resolve(res);
          }
        })
      )
      .catch((err) => {
        reject(CATCH_ERROR);
      });
  });
};

export const selectOTPMethod = (methodID) => {
  return new Promise((resolve, reject) => {
    fetch(urlprefix + "/SelectOTPMethod", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ methodindex: methodID }),
    })
      .then((res) => {
        if (res.status >= 500) {
          throw res;
        }
        res.json().then((json) => {
          if (json.error) {
            reject(json);
          } else {
            resolve(json);
          }
        });
      })
      .catch((err) => reject(err));
  });
};

export const getPrepop = (token) => {
  return new Promise((resolve, reject) => {
    fetch(urlprefix + "/RequestDetails", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token }),
    })
      .then((res) => {
        res.json().then((json) => {
          if (json.error) {
            reject(json);
          } else {
            resolve(json);
          }
        });
      })
      .catch((err) => reject(err));
  });
};

export const submitOTP = (otp) => {
  const result = new Promise((resolve, reject) =>
    fetch(urlprefix + "/SubmitOTP", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ otp }),
    }).then((res) =>
      res.json().then((json) => {
        if (json.error) {
          reject(json);
        } else {
          resolve(json);
        }
      })
    )
  );
  return result;
};

export const dropdownLookup = (data) => {
  return new Promise((resolve, reject) => {
    fetch(urlprefix + "/DropdownLookup", {
      method: "GET",
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(CATCH_ERROR);
      });
  });
};
